import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {

  @Input() image?:    string;
  @Input() date?:     string;
  @Input() title?:    string;
  @Input() link?:    string;
  @Input() eventId?:    string;
  @Input() slugs?:    string;
  @Input() local?:    string;
  @Input() skeleton?:  boolean;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  public open(): void {
    if(this.link){
      window.open(this.link, "_blank");
    }
    else if (this.slugs && this.slugs.length > 0) {
      this.router.navigate([this.slugs[0]]);
    } else {
      this.router.navigate(['/event', this.eventId]);
    }
  }
}
